"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var AppListItem_1 = __importDefault(require("./AppListItem"));
var AppList = function (_a) {
    var title = _a.title, apps = _a.apps, _b = _a.columns, columns = _b === void 0 ? 1 : _b;
    return (react_1.jsx(layout_1.Flex, { direction: "column", gap: "var(" + variables_1.Spacing.sp12 + ")", "data-6si-name": "app-switcher--app-list" },
        react_1.jsx("div", { css: { padding: "0px var(" + variables_1.Spacing.sp8 + ")" } },
            react_1.jsx(Text_1.default.Body, { size: "sm", weight: "semibold", color: "var(" + variables_1.TextColor.HEAD + ")" }, title)),
        react_1.jsx(layout_1.Grid, { autoColumns: "1fr", autoRows: "min-content", gap: "var(" + variables_1.Spacing.sp4 + ")" }, apps.map(function (app, i) { return (react_1.jsx(layout_1.Grid.Cell, { key: app.name, column: (i % columns) + 1, row: Math.floor(i / columns) + 1 },
            react_1.jsx(AppListItem_1.default, { app: app }))); }))));
};
exports.default = AppList;
